export default __webpack_public_path__ + "static/media/ITRealCase2.04946708.jpg";